import styled from 'styled-components'

export const BoxCardBankSlip = styled.div`
  /* background: var(--background-table); */
  border: 1px solid var(--border-color-table);
  box-sizing: border-box;
  border-radius: 13px;
  padding: 24px;
  width: 100%;
  margin: 16px 0;

  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export const IconMessageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`

export const IconMessage = styled.img`
  width: 26px;
`
